import { ArrowRightIcon } from "../../../../../common/icons/ArrowRightIcon";

export const OutgoingTransitionIcon = ({ fontSize = 12, ...props }) => {
  return (
    <ArrowRightIcon
      style={{ color: "var(--success-color)", fontSize }}
      {...props}
    />
  );
};
